export var menuItems={
  "data": [
    {
      "path": "/",
      "title": "Dashboard",
      "icon": "stroke-home",
      "iconf":"fill-home",
      "type": "link"
    },
    {
      "path": "/emitidos",
      "title": "Emitidos",
      "icon": "stroke-file",
      "iconf":"fill-file",
      "type": "link",
      "active": false
    },
    {
      "path": "/recibidos",
      "title": "Recibidos",
      "icon": "stroke-table",
      "iconf":"fill-table",
      "type": "link",
      "active": false
    },
    {
      "path": "/impuestos",
      "title": "Impuestos",
      "icon": "stroke-charts",
      "iconf":"fill-charts",
      "type": "link",
      "active": false
    },
    {
      "path": "/configuracion",
      "title": "Configuración",
      "icon": "stroke-icons",
      "iconf":"fill-icons",
      "type": "link",
      "active": false
    }
  ]
}